import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { sendInvite } from "../../../api/api";
import styles from "./SendInvite.module.css";

const SendInvite = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  const isValidEmail = (val) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(val).trim());

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");

    if (!email || !isValidEmail(email)) {
      setError("Please enter a valid email address.");
      return;
    }

    setBusy(true);
    try {
      const { data } = await sendInvite(email.trim().toLowerCase());
      setMessage(data?.message || "Invitation sent successfully.");
      setEmail("");
    } catch (err) {
      const apiMsg =
        err?.response?.data?.message ||
        "Failed to send invite. Please try again.";
      setError(apiMsg);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className={styles.container}>
      <h2>Send Customer Invite</h2>

      <p className={styles.helperText}>
        Enter the customer’s email. They’ll receive a link to register on{" "}
        <a
          href="https://www.tennisshop.ae/login.php?action=create_account"
          target="_blank"
          rel="noreferrer"
        >
          TennisShop.ae
        </a>{" "}
        to claim free stringing services (if eligible).
      </p>

      {message && <p className={styles.successMessage}>{message}</p>}
      {error && <p className={styles.errorMessage}>{error}</p>}

      <form onSubmit={handleSubmit} className={styles.form}>
        <label htmlFor="invite-email">Customer Email</label>
        <input
          id="invite-email"
          type="email"
          placeholder="customer@example.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          disabled={busy}
          className={styles.input}
        />

        <button type="submit" disabled={busy} className={styles.submitBtn}>
          {busy ? "Sending…" : "Send Invite"}
        </button>
      </form>

      <button className={styles.backButton} onClick={() => navigate(-1)}>
        Back
      </button>
    </div>
  );
};

export default SendInvite;
